const DISTRIBUTION_AVATAR = /^\/distribution\/artwork\/[a-f0-9]{40}$/i;

/**
 * Cast portraits are deliberately same-origin. Even if an API payload contains
 * an absolute S4 URL, the browser DOM never exposes that host or its IP.
 */
export function castAvatarUrl(profile: string | null | undefined): string | null {
  const raw = String(profile ?? '').trim();
  if (!raw) return null;
  try {
    const parsed = new URL(raw, 'http://artwork.local');
    if (!DISTRIBUTION_AVATAR.test(parsed.pathname)) return null;
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return null;
  }
}
